import React, { useEffect, useState } from 'react'
import Paper from '@mui/material/Paper';
import { Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import api from '../../API/api';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';

const AllEvents = () => {

    const [events, setEvents] = useState();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        getEventAndNotice();
    }, []);

    const getEventAndNotice = () => {
        api.getEventAndNotice().then((res) => {
            // console.log(res);
            setEvents(res.data.events)
        })
    }





    return (
        <>
            <div className="col-md-12">
                <Paper elevation={3}>

                    <div className='p-3'>
                        <div className='text-center p-3'>
                            <h3> Events </h3>
                        </div>
                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'black' }} />

                        <div className="row">

                            {events && events.map((ev) =>
                            (
                                <div className="col-md-4 p-3">
                                    <Paper elevation={1} sx={{
                                        ':hover': {
                                            boxShadow: 10,
                                        },
                                    }} className='event-box'>
                                        <div className='row'>
                                            <div className='col-5 overflow-hidden'>
                                                <img src={`${process.env.REACT_APP_BACKEND}assets/events/img/${ev.image}`} className=' col-12' alt={ev.event} />
                                                <div className='text-center p-2'>
                                                    <div className='locationDate px-3'>
                                                        <EventIcon style={{ fontSize: 18 }} /> &nbsp;
                                                        {new Date(ev.date).toDateString().slice(4, 20)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-7'>
                                                <div className='p-2'>
                                                    <div>
                                                        <h6 style={{ height: 40, overflow: 'hidden' }}>
                                                            <strong> {ev.event}</strong>
                                                        </h6>
                                                    </div>
                                                    <div className='row align-item-center '>
                                                        <div className='col-md-7 p-0'>
                                                            {ev.school &&
                                                                <div className='locationNotice py-1'>
                                                                    <LocationOnIcon style={{ fontSize: 18 }} />
                                                                    <small className=''> {ev.location ? ev.location : ev.school}</small>
                                                                </div>
                                                            }
                                                        </div>

                                                    </div>
                                                    <div className='pt-2 events-res' >
                                                        <span className='align-bottom'>
                                                            <div dangerouslySetInnerHTML={{ __html: ev.details }} />
                                                        </span>
                                                    </div>
                                                    <div className='text-end'>
                                                        <small>
                                                            <Link to='/singleEvent' state={ev}>Read more...</Link>
                                                        </small>
                                                    </div>
                                                </div>
                                                {/* </a> */}
                                            </div>


                                        </div>
                                    </Paper>
                                </div>
                            ))}


                        </div>

                    </div>

                </Paper>
            </div>
        </>
    )
}

export default AllEvents